var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    stroke: "#585858",
    strokeWidth: 1.395,
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.558 15.163a6.98 6.98 0 006.977-6.977 6.98 6.98 0 00-6.977-6.977 6.98 6.98 0 00-6.977 6.977 6.98 6.98 0 006.977 6.977z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.528 6.093a2.097 2.097 0 012.328-1.368c.487.084.929.337 1.247.715a2.1 2.1 0 01.492 1.351c0 1.395-2.093 2.093-2.093 2.093m.056 2.79h.008",
    strokeLinecap: "round"
  })));
}
export default SvgQuestionIcon;